import Steps2 from './Steps2'
export default Steps2
